import React from 'react'
import CustomModal from 'components/global/CustomModal'
import { leagueInvitationStore } from 'state/league/leagueInvitation'
import InviteOrgContent from './ModalContent/InviteOrgContent'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { myStore } from 'state/store'
import { useInviteOrganization } from 'api/league/LeagueInvitation/LeagueInvitation'
import { leagueEventStore } from 'state/league/leagueEvent'

const InviteOrganization: React.FC = () => {
  const { leagueData, setLeagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    setLeagueData: store.setLeagueData,
  }))
  const id = leagueData?._id || ''
  const { inviteModal, setInviteModal, selectedOrgsIds, setSelectedOrgsIds } =
    leagueInvitationStore(store => ({
      inviteModal: store.inviteModal,
      setInviteModal: store.setInviteModal,
      selectedOrgsIds: store.selectedOrgsIds,
      setSelectedOrgsIds: store.setSelectedOrgsIds,
    }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)

  const { mutate: inviteOrganization } = useInviteOrganization()

  const closeModal = () => {
    setSelectedOrgsIds([])
    setInviteModal(false)
  }

  const handleSubmit = () => {
    const payload = {
      organizationIds: selectedOrgsIds,
    }
    setModalBtnLoader(true)
    inviteOrganization(
      { payload, leagueId: id },
      {
        onSuccess: data => {
          setLeagueData({
            ...leagueData,
            guestOrganizations: [...(leagueData.guestOrganizations ?? []), ...data],
          })
          closeModal()
          setModalBtnLoader(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      },
    )
  }

  return (
    <>
      <CustomModal
        openModal={inviteModal}
        isCloseModalCustom={true}
        title="Invite Organization"
        closeModal={closeModal}
        width={800}
        footer={
          selectedOrgsIds.length ? (
            <CustomModalFooter
              multibutton={true}
              btnText={'Close,Invite'}
              btnAlignment={'justify-between'}
              closeModal={closeModal}
              onSubmit={handleSubmit}
            />
          ) : (
            false
          )
        }
      >
        <InviteOrgContent />
      </CustomModal>
    </>
  )
}

export default InviteOrganization
